// Typography tokens from Figma text styles (node 87:2): Funnel Display (headings) + Geist (body).

export const fontFamily = {
  heading: "'Funnel Display Variable', 'Funnel Display', sans-serif",
  body: "'Geist Variable', 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
} as const;

export const fontSize = {
  9: '9px',
  10: '10px',
  11: '11px',
  12: '12px',
  13: '13px',
  14: '14px',
  16: '16px',
  18: '18px',
  20: '20px',
  24: '24px',
  28: '28px',
  32: '32px',
  36: '36px',
  40: '40px',
  44: '44px',
} as const;

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

export const lineHeight = {
  heading: 1.2,
  body: 1.5,
  tight: 1.25,
  loose: 1.75,
} as const;

export type TextRole = {
  family: keyof typeof fontFamily;
  size: keyof typeof fontSize;
  weight: number;
  lineHeight: number;
};

export const textRoles: Record<
  'display' | 'h1' | 'h2' | 'h3' | 'h4' | 'body' | 'bodySm' | 'caption' | 'overline' | 'code',
  TextRole
> = {
  display: {
    family: 'heading',
    size: 40,
    weight: fontWeight.semibold,
    lineHeight: lineHeight.heading,
  },
  h1: { family: 'heading', size: 32, weight: fontWeight.semibold, lineHeight: lineHeight.heading },
  h2: { family: 'heading', size: 28, weight: fontWeight.semibold, lineHeight: lineHeight.heading },
  h3: { family: 'heading', size: 24, weight: fontWeight.semibold, lineHeight: lineHeight.heading },
  h4: { family: 'heading', size: 20, weight: fontWeight.semibold, lineHeight: lineHeight.heading },
  body: { family: 'body', size: 14, weight: fontWeight.regular, lineHeight: lineHeight.body },
  bodySm: { family: 'body', size: 13, weight: fontWeight.regular, lineHeight: lineHeight.body },
  caption: { family: 'body', size: 12, weight: fontWeight.regular, lineHeight: lineHeight.body },
  overline: { family: 'body', size: 11, weight: fontWeight.medium, lineHeight: lineHeight.body },
  code: { family: 'mono', size: 13, weight: fontWeight.regular, lineHeight: lineHeight.body },
};
